// LinkButton.jsx
import React from 'react';
import './App.css'; // Asegúrate de importar tu CSS

const LinkButton = ({ icon: Icon, text, link }) => {
  // Los iconos se pasan como componentes (por ejemplo, de react-icons)
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="link-button"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '16px 20px',
        marginBottom: '16px',
        width: '100%',
        textDecoration: 'none',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        color: '#0D1117' // Color del texto
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {Icon && <Icon size={24} style={{ marginRight: '16px', color: '#3b82f6' }} />}
        <span style={{ fontWeight: '600', fontSize: '18px' }}>{text}</span>
      </div>
      <div style={{ color: '#6B7280', fontSize: '24px' }}>
        {/* Representa el menú de 3 puntos */}
      </div>
    </a>
  );
};

export default LinkButton;